import React from "react";
import { Message } from "semantic-ui-react";
import useIntlh from "../hooks/use-intlh";

export const BlackFridayContext = React.createContext();
export const BlackFridayProVoucher = "BFRIDAY_PRO";
export const BlackFridayProDiscount = 0.5;
export const BlackFriday3yRenewalVoucher = "BFRIDAY_UP";
export const BlackFriday3yRenewalDiscount = 0.25;

export const isBlackFridayFn = () => {
  // const now = new Date();
  // const isBlackFriday =
  //   (now.getDate() === 24 || now.getDate() === 25 || now.getDate() === 26 || now.getDate() === 27) &&
  //   now.getMonth() === 10;
  // return isBlackFriday;
  return false;
};

export const BlackFridayBanner = ({ product = "Screenpresso PRO" }) => {
  const [, intlh] = useIntlh();
  const isBlackFriday = isBlackFridayFn();

  if (isBlackFriday) {
    return (
      <Message
        icon="gift"
        header="BLACK FRIDAY"
        content={
          <span
            dangerouslySetInnerHTML={{
              __html: intlh("pricing.black-friday-50p", {
                voucher: BlackFridayProVoucher,
                product,
              }),
            }}
          />
        }
        color="black"
      />
    );
  }
};

export const RenewalBlackFridayBanner = ({ product = "Screenpresso PRO" }) => {
  const [, intlh] = useIntlh();
  const isBlackFriday = isBlackFridayFn();

  if (isBlackFriday) {
    return (
      <Message
        icon="gift"
        header="BLACK FRIDAY"
        content={
          <span
            dangerouslySetInnerHTML={{
              __html: intlh("pricing.black-friday-25p-3y-renewal", {
                voucher: BlackFriday3yRenewalVoucher,
                product,
              }),
            }}
          />
        }
        color="black"
      />
    );
  }

  return null;
};
